import { render, staticRenderFns } from "./refundManagement.vue?vue&type=template&id=770b172d&scoped=true"
import script from "./refundManagement.vue?vue&type=script&lang=js"
export * from "./refundManagement.vue?vue&type=script&lang=js"
import style0 from "./refundManagement.vue?vue&type=style&index=0&id=770b172d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "770b172d",
  null
  
)

export default component.exports